import React from 'react';

import MuiAvatar, { AvatarProps as MuiAvatarProps } from '@mui/material/Avatar';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Avatar = withCoreProps<AvatarProps>(
  ({ children, className, ...props }: React.PropsWithChildren<AvatarProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiAvatar {...props} className={clsxClass}>
        {children}
      </MuiAvatar>
    );
  },
);

export interface AvatarProps extends MuiAvatarProps, CoreProps {}
